import { InovicesType } from '../../redux/data/dataTypes';
import api from '../axios/axiosInstance';

const getInvoices = async (): Promise<InovicesType[]> => {
  const response = await api.get(`/users/invoices`);
  return response.data;
};

export default getInvoices;
